export default __webpack_public_path__ + "static/media/Skey-Network-Planet.de98c4b3.png";